var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTop),expression:"showTop"}],staticClass:"scrollTop",on:{"click":_vm.toTop}},[_c('svg-icon',{staticClass:"backtotop",attrs:{"icon-class":"top"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }